// src/components/tables/RecentGrainTable.js
import React, { useEffect, useState } from "react";
import { client } from "../../sanityClient";
import { formatDateBS } from "../../utils/dateUtils";
import { useNavigate } from "react-router-dom";
import "./RecentTable.css";

export default function RecentGrainTable() {
    const [transactions, setTransactions] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        client
            .fetch(
                `*[_type == "grainTransaction"] | order(time desc) [0...5] {
          _id, buyOrSell, quantity, rate, finalPrice, time, grain->{grainName}
        }`
            )
            .then(setTransactions);
    }, []);

    return (
        <div className="recent-table-wrapper">
            <h6 className="recent-table-title text-center">Recent Grain Transactions</h6>
            <table className="recent-table">
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Grain</th>
                        <th>Qty (kg)</th>
                        <th>Rate (₹)</th>
                        <th>Final (₹)</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {transactions.length === 0 ? (
                        <tr>
                            <td colSpan="6" className="text-center py-4 text-muted">
                                No transactions
                            </td>
                        </tr>
                    ) : (
                        transactions.map((t) => (
                            <tr key={t._id}>
                                <td>
                                    <span
                                        className={`badge ${t.buyOrSell === "Buy" ? "badge-buy" : "badge-sell"
                                            }`}
                                    >
                                        {t.buyOrSell}
                                    </span>
                                </td>
                                <td>{t.grain?.grainName || "-"}</td>
                                <td>{t.quantity}</td>
                                <td>{t.rate}</td>
                                <td>
                                    <span className={`badge ${t.buyOrSell === "Buy" ? "badge-buy" : "badge-sell"}`}>
                                        {t.buyOrSell === "Buy" ? "-" : "+"}₹{t.finalPrice}
                                    </span>
                                </td>
                                <td>{formatDateBS(t.time)}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            <div className="text-center mt-3">
                <button className="view-all-btn" onClick={() => navigate("/grain")}>
                    View All →
                </button>
            </div>
        </div>
    );
}